import { render } from "./AuthSplitLayout.vue?vue&type=template&id=51d89432&scoped=true"
import script from "./AuthSplitLayout.vue?vue&type=script&lang=js"
export * from "./AuthSplitLayout.vue?vue&type=script&lang=js"

import "./AuthSplitLayout.vue?vue&type=style&index=0&id=51d89432&scoped=true&lang=css"

import exportComponent from "../../../../../../vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d89432"]])

export default __exports__